export enum VisaCheckoutResponseType {
  cancel = "payment.cancel",
  error = "payment.error",
  success = "payment.success",
  prePayment = "pre-payment.user-data-prefill",
}
